module.exports = __webpack_public_path__ + "img/px-road-layers-75pct.93ea27c0.jpg";